import { Component, OnInit } from '@angular/core';

import { APICallService } from 'src/app/services/api-call.service'
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { AppMessageService } from 'src/app/services/app-message.service';

import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';

import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { LeaveConfirmation } from '../../common/guard/check.guard';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';

@Component({
  selector: 'faq-main-maintenance',
  templateUrl: './faq-main-maintenance.component.html',
  styleUrls: ['./faq-main-maintenance.component.css']
})
export class FaqMainMaintenanceComponent implements OnInit, LeaveConfirmation {

  datePipe = new DatePipe('en-us');

  addDisabled: boolean = true;
  saveDisabled: boolean = true;
  deleteDisabled: boolean = true;
  sublineDisabled: boolean = true;
  tranPosted: boolean = false;
  noLoadingInProcess: boolean = true;
  validated: boolean = false;
  submitted: boolean = false;
  isFAQSelected: boolean = false;
  isSuccessSaved: boolean = false;
  private moduleId: string = 'BMM074';
  public moduleName: string = this.jsonDataService.data.moduleList.find((a: any) => a.moduleId === this.moduleId)?.moduleDesc?.toUpperCase() ?? "";

  sortSeqField: string = '';
  currentUser: string = this.jsonDataService.retrieveFromStorage("userId");
  rowClickedData: any;

  effDate = new FormControl(new Date());

  groupCodes: any = [];
  tempAddedData: any = [];
  tempUpdateData: any = [];
  tempData: any = [];

  faqMainForm = this.fb.group({
    questionNo: [null],
    questionNum: [null],
    sortSeq: [null],
    activeTag: ['A', [Validators.required]],
    groupCd: [null, [Validators.required]],
    question: [null, [Validators.required]],
    answer: [null, [Validators.required]],
    remarks: [null],
    userID: [null],
    lastUserUpdate: [null],
    mode: [null]
  });

  constructor(
    private _APICallService: APICallService,
    public _Dialog: MatDialog,
    private fb: FormBuilder,
    private formService: FormService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    private jsonDataService: JsonDataService,
    private securityService: SecurityService
  ) { }

  canDeactivate(): Observable<boolean> | boolean {
    try {
      if (this.tempAddedData != '' || this.tempUpdateData != '') {
        return false;
      } else {
        return true;
      }
    } catch (e) {
    console.error(e);
      return true;
    }
  }

  tblConfigFAQMain: any = {
    cols: [
      {
        key: "QUESTION_NUM",
        header: "Question No.",
        dataType: "string",
        width: '14%'
      },
      {
        key: "QUESTION",
        header: "Question",
        dataType: "string",
        disabled: false
      },
      {
        key: "ANSWER",
        header: "Answer",
        dataType: "string",
        disabled: false,
      },
      {
        key: "SORT_SEQ",
        header: "Sequence No.",
        dataType: "string",
        disabled: false,
        width: '14%'
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox",
        disabled: true,
        width: '55px'
      }
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15
  }

  ngOnInit(): void {
    try {
      this._APICallService.refreshNeeded$
        .subscribe(() => {
          this.getAllFAQMain();
        })
      this.getAllFAQMain();
      this.groupCodes = this.jsonDataService.data.refCds.filter((e: any) => e.rvDomain == "BMM074.GROUP_CD").map((data: any) => { return { cd: data.rvLowValue, name: data.rvMeaning } });
    }
    catch (e) {
    console.error(e);
    }
  }

  initOnGet(): void {
    try {
      this._APICallService.refreshNeeded$
        .subscribe(() => {
          this.getAllFAQMain();
        });
      this.getAllFAQMain();
    }
    catch (e) {
    console.error(e);
    }
  }

  getAllFAQMain() {
    try {
      this.tblConfigFAQMain.loading = true;
      this.jsonDataService.contorlLoading(true);
      this._APICallService.getFAQMain({
        moduleId: this.moduleId,
        userId: this.userDetailService.userId,
        type: "MODULE"
      }).subscribe({
        next: (response: any) => {
          this.securityService.checkRequestKeyResponse(response, () => {
            this.securityService.hasValidCsrfToken(response, () => {
              if (response.status === 'SUCCESS') {
                let data = JSON.parse(this.jsonDataService.decrypt(response.response));
                this.jsonDataService.contorlLoading(false);
                this.tblConfigFAQMain.loading = false;
                this.tblConfigFAQMain.tblData = data;
              }
              else {
                this.jsonDataService.contorlLoading(false);
                this.tblConfigFAQMain.loading = false;
                this.appMessageService.showAppMessage(response.message, "error");
              }
            });
          });
        },
        error: (response: any) => {
          this.securityService.checkRequestKeyResponse(response, () => {
            this.securityService.hasValidCsrfToken(response, () => {
              this.jsonDataService.contorlLoading(false);
              this.tblConfigFAQMain.loading = false;
            });
          });
        },
      });
    }
    catch (e) {
    console.error(e);
    }
  }

  insertFAQMain() {
    try {
      this.tranPosted = true;
      this.validateInsert();
      if (this.validated) {
        this.addFormToTable();
      }
      this.tblConfigFAQMain.tblData = [...this.tblConfigFAQMain.tblData];
    }
    catch (e) {
    console.error(e);
    }
  }

  addFormToTable() {
    try {
      this.faqMainForm.patchValue({
        activeTag: this.faqMainForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date(),
      });
      let formToData: any = { // this.datePipe.transform(new Date(), 'MM/dd/yyyy')
        QUESTION_NO: this.faqMainForm.get('questionNo')?.value,
        SORT_SEQ: this.faqMainForm.get('sortSeq')?.value,
        ACTIVE_TAG: this.faqMainForm.get('activeTag')?.value,
        GROUP_CD: this.faqMainForm.get('groupCd')?.value,
        QUESTION: this.faqMainForm.get('question')?.value,
        ANSWER: this.faqMainForm.get('answer')?.value,
        REMARKS: this.faqMainForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.faqMainForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.faqMainForm.get('userID')?.value,
        MODE: 'I'
      }
      this.tblConfigFAQMain.tblData.unshift(formToData);
      this.tempAddedData.push(formToData);
      this.resetFormValues();
      this.appMessageService.showAppMessage("FAQ Main details added!", "success");
    }
    catch (e) {
    console.error(e);
    }
  }

  updateFAQMain() {
    try {
      this.tranPosted = true;
      this.validateUpdate();
      if (this.validated) {
        this.updateFormTable();
      }
      this.tblConfigFAQMain.tblData = [...this.tblConfigFAQMain.tblData];
    }
    catch (e) {
    console.error(e);
    }
  }

  updateFormTable() {
    try {
      let tempInsertChecker = this.tempAddedData.find(
        (faq: { QUESTION: any; }) => faq.QUESTION == this.faqMainForm.get('question')?.value);
      let tempUpdateChecker = this.tempUpdateData.find(
        (faq: { QUESTION_NO: any; }) => faq.QUESTION_NO == this.faqMainForm.get('questionNo')?.value);

      this.tableDataUpdate();
      if (tempInsertChecker != null && tempInsertChecker != '') {
        tempInsertChecker.SORT_SEQ = this.faqMainForm.get('sortSeq')?.value;
        tempInsertChecker.ACTIVE_TAG = this.faqMainForm.get('activeTag')?.value;
        tempInsertChecker.GROUP_CD = this.faqMainForm.get('groupCd')?.value;
        tempInsertChecker.QUESTION = this.faqMainForm.get('question')?.value;
        tempInsertChecker.ANSWER = this.faqMainForm.get('answer')?.value;
        tempInsertChecker.REMARKS = this.faqMainForm.get('remarks')?.value;
        tempInsertChecker.USER_ID = this.faqMainForm.get('userID')?.value;
        tempInsertChecker.MODE = 'I';
      }
      else if (tempUpdateChecker != null && tempUpdateChecker != '') {
        tempUpdateChecker.QUESTION_NO = this.faqMainForm.get('questionNo')?.value;
        tempUpdateChecker.SORT_SEQ = this.faqMainForm.get('sortSeq')?.value;
        tempUpdateChecker.ACTIVE_TAG = this.faqMainForm.get('activeTag')?.value;
        tempUpdateChecker.GROUP_CD = this.faqMainForm.get('groupCd')?.value;
        tempUpdateChecker.QUESTION = this.faqMainForm.get('question')?.value;
        tempUpdateChecker.ANSWER = this.faqMainForm.get('answer')?.value;
        tempUpdateChecker.REMARKS = this.faqMainForm.get('remarks')?.value;
        tempUpdateChecker.USER_ID = this.faqMainForm.get('userID')?.value;
        tempUpdateChecker.MODE = 'U';
      }
      else {
        this.tempUpdateData.push(this.formValueToData());
      }
      this.saveDisabled = false;
      this.resetFormValues();
      this.appMessageService.showAppMessage("FAQ Main updated!", "success");
    }
    catch (e) {
    console.error(e);
    }
  }

  tableDataUpdate() {
    try {
      this.faqMainForm.patchValue({
        activeTag: this.faqMainForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let updateIndex = this.tblConfigFAQMain.tblData.indexOf(this.rowClickedData);
      this.tblConfigFAQMain.tblData[updateIndex] = {
        QUESTION_NO: this.faqMainForm.get('questionNo')?.value,
        QUESTION_NUM: this.faqMainForm.get('questionNum')?.value,
        SORT_SEQ: this.faqMainForm.get('sortSeq')?.value,
        ACTIVE_TAG: this.faqMainForm.get('activeTag')?.value,
        GROUP_CD: this.faqMainForm.get('groupCd')?.value,
        QUESTION: this.faqMainForm.get('question')?.value,
        ANSWER: this.faqMainForm.get('answer')?.value,
        REMARKS: this.faqMainForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.faqMainForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.faqMainForm.get('userID')?.value,
        MODE: 'U'
      };
    }
    catch (e) {
    console.error(e);
    }
  }

  formValueToData() {
    try {
      let formToData: any = {
        QUESTION_NO: this.faqMainForm.get('questionNo')?.value,
        SORT_SEQ: this.faqMainForm.get('sortSeq')?.value,
        ACTIVE_TAG: this.faqMainForm.get('activeTag')?.value,
        GROUP_CD: this.faqMainForm.get('groupCd')?.value,
        QUESTION: this.faqMainForm.get('question')?.value,
        ANSWER: this.faqMainForm.get('answer')?.value,
        REMARKS: this.faqMainForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.faqMainForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.faqMainForm.get('userID')?.value,
        MODE: 'U'
      }
      return formToData;
    }
    catch (e) {
    console.error(e);
    }
  }

  toSave() {
    try {
      this.noLoadingInProcess = false;
      this.jsonDataService.contorlLoading(true);
      this.formService.showFormLoader(null, "generate-faq-main-form", "Please wait ...", null, null, true);
      this.tempData = [...this.tempAddedData, ...this.tempUpdateData];
      if (this.tempData.length>0) {
        this.toSaveTempData();
      }
      // if(this.tempAddedData.length!=0) {
      //   this._APICallService.saveFAQMain(this.tempAddedData)
      //   .subscribe({
      //     next: (response : any) => {
      //       if (response.status == "SUCCESS" && this.tranPosted) {
      //         this.openDialog('SUCCESS', 'New FAQ Main details Successfully saved!');
      //         this.initOnGet();
      //       }   
      //       else {
      //         this.openDialog('ERROR', 'An error has occured while saving details for new FAQ Main');
      //       }
      //     }, 
      //     error: () => {
      //       this.openDialog('ERROR', 'An error has occured while saving details for new FAQ Main');
      //     }
      //   });
      // }

      // if(this.tempUpdateData.length!=0) {
      //   this._APICallService.saveFAQMain(this.tempUpdateData)
      //   .subscribe({
      //     next: (response : any) => {
      //       if (response.status == "SUCCESS" && this.tranPosted) {
      //         this.openDialog('SUCCESS', 'Existing FAQ Main details successfully saved!');
      //         this.initOnGet();
      //       }  
      //       else {
      //         this.openDialog('ERROR', 'An error has occured while saving details for existing FAQ Main');
      //       }
      //     }, 
      //     error: () => {
      //       this.openDialog('ERROR', 'An error has occured while saving details for existing FAQ Main');
      //     }
      //   });
      // }

      // this.resetFormValues();
      // this.tempAddedData = [];
      // this.tempUpdateData = [];
    }
    catch (e) {
    console.error(e);
    }
  }

  private toSaveTempData(): void {
    this._APICallService.saveFAQMain(this.tempData).subscribe({
      next: (response: any) => {
        this.securityService.checkRequestKeyResponse(response, () => {
          this.securityService.hasValidCsrfToken(response, () => {
            if (response.status == "SUCCESS" && this.tranPosted) {
              this.jsonDataService.contorlLoading(false);
              this.openDialog('SUCCESS', 'FAQ Main details successfully saved!');
              this.initOnGet();
              this.tempAddedData = [];
              this.tempUpdateData = [];
              this.tempData = [];
              this.resetFormValues();
            }
            else {
              this.jsonDataService.contorlLoading(false);
              this.openDialog('ERROR', 'An error has occured while saving details for FAQ Main');
            }
          });
        });
      },
      error: () => {
        this.jsonDataService.contorlLoading(false);
        this.openDialog('ERROR', 'An error has occured while saving details for FAQ Main');
      }
    });
  }

  deleteFAQMain() {
    try {
      let clickData = this.rowClickedData;
      this.tblConfigFAQMain.tblData = this.tblConfigFAQMain.tblData.filter(
        function (e: any) {
          return e.QUESTION != clickData.QUESTION;
        }
      );
      this.tempAddedData = this.tempAddedData.filter(
        function (e: any) {
          return e.QUESTION != clickData.QUESTION;
        }
      );
      this.resetFormValues();
    }
    catch (e) {
    console.error(e);
    }
  }

  saveChecker() {
    try {
      if ((this.tempAddedData == null || this.tempAddedData == '') && (this.tempUpdateData == null || this.tempUpdateData == '')) {
        return true;
      }
      else {
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return true;
    }
  }

  deleteChecker(ev: any) {
    try {
      let tempDataFlag;
      tempDataFlag = this.tempAddedData.filter(function (e: any) {
        return e.QUESTION_NUM == ev.QUESTION_NUM;
      });
      if (tempDataFlag == '' || tempDataFlag == null) {
        return true;
      } else {
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return true;
    }
  }

  onRowClick(ev: any) {
    try {
      if (ev != null) {
        this.rowClickedData = ev;
        this.faqMainForm.get('questionNum')?.disable();
        this.loadFormValues();
        this.saveDisabled = this.saveChecker();
        this.deleteDisabled = this.deleteChecker(ev);

      }
      else {
        this.resetFormValues();
      }
    }
    catch (e) {
    console.error(e);
    }
  }

  loadFormValues() {
    try {
      this.faqMainForm.patchValue({
        questionNo: this.rowClickedData.QUESTION_NO,
        questionNum: this.rowClickedData.QUESTION_NUM,
        sortSeq: this.rowClickedData.SORT_SEQ,
        activeTag: this.rowClickedData.ACTIVE_TAG,
        groupCd: this.rowClickedData.GROUP_CD,
        question: this.rowClickedData.QUESTION,
        answer: this.rowClickedData.ANSWER,
        remarks: this.rowClickedData.REMARKS,
        userID: this.rowClickedData.USER_ID,
        lastUserUpdate: this.rowClickedData.LAST_USER_UPDATE
      });
      this.addDisabled = true;
      this.isFAQSelected = true;
    }
    catch (e) {
    console.error(e);
    }
  }

  resetFormValues() {
    try {
      //this.faqMainForm.get('questionNo')?.enable();
      this.faqMainForm.patchValue({
        questionNo: null,
        questionNum: null,
        sortSeq: null,
        activeTag: 'A',
        groupCd: null,
        question: null,
        answer: null,
        remarks: null,
        userID: null,
        lastUserUpdate: null
      });

      this.addDisabled = false;
      this.saveDisabled = this.saveChecker();
      this.deleteDisabled = true;
      this.isFAQSelected = false;

      this.rowClickedData = '' || null;
    }
    catch (e) {
    console.error(e);
    }
  }

  openDialog(title: any, message: any) {
    try {
      this.noLoadingInProcess = true;
      this.formService.hideFormLoader("generate-faq-main-form");
      this._Dialog.open(DialogMsgComponent, {
        disableClose: true,
        width: "500px",
        data: {
          title: title,
          content: message
        }
      });
    } catch (e) {
    console.error(e);
    }
  }

  validateInsert() {
    try {
      this.validated = false;
      if (!this.requiredFieldCheck()) {
        // this.openDialog('ERROR', 'Kindly fill-out required fields.');
        setTimeout(() => {                           //10 secs countdown
          this.formService.hideFormMsg("faq-main-error-message");
        }, 10000);
      }
      else if (!this.sortSeqDupCheck()) {
        // this.openDialog('ERROR', 'Sequence No. already exists. Please choose a different Sequence No.');
        setTimeout(() => {
          this.formService.hideFormMsg("faq-main-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }

  validateUpdate() {
    try {
      this.validated = false;
      if (!this.requiredFieldCheck()) {
        // this.openDialog('ERROR', 'There are missing information. Please provide the necessary information needed.');
        setTimeout(() => {
          this.formService.hideFormMsg("faq-main-error-message");
        }, 10000);
      }
      else if (!this.sortSeqDupCheck()) {
        // this.openDialog('ERROR', 'Sequence No. already exists. Please choose a different Sequence No.');
        setTimeout(() => {
          this.formService.hideFormMsg("faq-main-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }

  sortSeqDupCheck() {
    try {
      let sortSeqForm = this.faqMainForm.get('sortSeq')?.value;
      if (sortSeqForm) {
        this.sortSeqField = this.tblConfigFAQMain.tblData.filter((e: any) => {
          return (!this.isFAQSelected) ? (e.SORT_SEQ == sortSeqForm) : (this.rowClickedData.SORT_SEQ != sortSeqForm && e.SORT_SEQ == sortSeqForm);
        });
        if (this.sortSeqField == '' || this.sortSeqField == null) {
          return true;
        } else {
          this.formService.showFormMsg("faq-main-error-message", 'Sequence No. already exists. Please choose a different Sequence No.', "E");
          return false;
        }
      }
      return true;
    }
    catch (e) {
    console.error(e);
      return false;
    }
  }

  requiredFieldCheck() {
    try {
      if (this.faqMainForm.get('activeTag')?.value == '' || this.faqMainForm.get('activeTag')?.value == null
        || this.faqMainForm.get('groupCd')?.value == '' || this.faqMainForm.get('groupCd')?.value == null
        || this.faqMainForm.get('question')?.value == '' || this.faqMainForm.get('question')?.value == null || this.onlyWhitespace(this.faqMainForm.get('question')?.value ?? '')
        || this.faqMainForm.get('answer')?.value == '' || this.faqMainForm.get('answer')?.value == null || this.onlyWhitespace(this.faqMainForm.get('answer')?.value ?? '')) {
        this.formService.showFormMsg("faq-main-error-message", 'There are missing information. Please provide the necessary information needed.', "E");
        return false;
      }
      else {
        return true;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  }

  private onlyWhitespace(val: string) {
    return (val ?? '').trim().length === 0;
  }

}
